import { render, staticRenderFns } from "./ZhipeiGoods.vue?vue&type=template&id=44328910&scoped=true"
import script from "./ZhipeiGoods.vue?vue&type=script&lang=js"
export * from "./ZhipeiGoods.vue?vue&type=script&lang=js"
import style0 from "./ZhipeiGoods.vue?vue&type=style&index=0&id=44328910&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44328910",
  null
  
)

export default component.exports